import { refundMethodsLabels } from './constants'

export const getAvailableRefundMethods = refundMethods => {
  return refundMethods
    ?.filter(method => method.enabled)
    ?.map(method => ({ label: refundMethodsLabels[method.name], value: method.name }))
}
